const overrideFormControl = (theme) => {
  theme.overrides["MuiFormControl"] = {
    root: {
      marginBottom: theme.spacing(1)
    }
  };
}

export default overrideFormControl;